export enum EnvironmentUrl {
    PROD_ENV_URL = "https://www.pearch.se"
}